/* ============================================================
   Barra de progresso do Desconto Progressivo
   - Renderiza só na coleção alvo (guard no Liquid)
   - Suporta N instâncias na página (barra fixa do topo + dentro do cart drawer)
   - Lê o carrinho via /cart.js e reage a eventos (sem polling)
   - Copy/marcadores/celebração derivados dos tiers (config em #dp-bar-config)
   ============================================================ */
(function () {
  // Sem nenhuma barra na página -> nada a fazer.
  if (!document.querySelector('.dp-sticky')) return;

  /* ---------- Config: fonte única de verdade (serializada no Liquid) ---------- */
  var cfg = {};
  try {
    var raw = document.getElementById('dp-bar-config');
    if (raw) cfg = JSON.parse(raw.textContent);
  } catch (e) { cfg = {}; }

  var TIERS = (cfg.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
  if (!TIERS.length) {
    TIERS = [{ min: 3, pct: 12 }, { min: 4, pct: 14 }, { min: 6, pct: 18 }, { min: 8, pct: 20 }];
  }
  var FIRST = TIERS[0];
  var LAST = TIERS[TIERS.length - 1];
  var MAX_MIN = LAST.min;

  var rawExcluded = cfg.excludedHandles || '';
  var EXCLUDED = (Array.isArray(rawExcluded) ? rawExcluded : String(rawExcluded).split(/\r?\n/))
    .map(function (h) { return String(h).trim().toLowerCase(); })
    .filter(Boolean);

  // Gatilho de visibilidade da barra FIXA do topo: aparece ao rolar além do banner.
  var hero = document.querySelector('.collection-banner') || document.querySelector('.dp-steps');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastTierIndex = null; // null = ainda não inicializado (não celebra na carga)
  var celebrateTimer = null;

  /* ---------- Estado a partir da contagem de peças ---------- */
  function currentTierIndex(pecas) {
    var idx = -1;
    for (var i = 0; i < TIERS.length; i++) { if (pecas >= TIERS[i].min) idx = i; }
    return idx;
  }
  function nextTierFor(pecas) {
    for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].min > pecas) return TIERS[i]; }
    return null;
  }

  function buildState(pecas) {
    var idx = currentTierIndex(pecas);
    var current = idx >= 0 ? TIERS[idx] : null;
    var next = nextTierFor(pecas);

    var state = {
      idx: idx,
      fill: Math.min(pecas / MAX_MIN, 1) * 100,
      badge: current ? current.pct + '% OFF' : '',
      msg: '',
      urgent: false,
      success: false
    };

    if (!current) {
      // Abaixo do primeiro tier (0, 1, 2 peças)
      if (pecas <= 0) {
        state.msg = 'Monte seu kit: a partir de ' + FIRST.min + ' peças, ' + FIRST.pct + '% OFF no Pix';
      } else {
        var faltam = FIRST.min - pecas;
        if (faltam === 1) {
          state.msg = 'Falta só 1 peça para desbloquear ' + FIRST.pct + '% OFF no Pix';
          state.urgent = true;
        } else {
          state.msg = 'Faltam ' + faltam + ' peças para desbloquear ' + FIRST.pct + '% OFF no Pix';
        }
      }
    } else if (!next) {
      // Tier máximo (8+)
      state.msg = 'Desconto máximo desbloqueado: ' + current.pct + '% OFF no Pix em todo o kit ✓';
      state.success = true;
    } else {
      var need = next.min - pecas;
      var nextIsMax = (next === LAST);
      if (pecas === current.min) {
        // Acabou de cruzar este tier -> mensagem de desbloqueio
        if (need === 1) {
          state.msg = current.pct + '% OFF desbloqueado ✓ — adicione +1 peça e suba para ' + next.pct + '%';
        } else {
          var alvo = nextIsMax ? ('o máximo de ' + next.pct + '%') : (next.pct + '%');
          state.msg = current.pct + '% OFF desbloqueado ✓ — faltam ' + need + ' peças para ' + alvo;
        }
      } else {
        // Entre thresholds -> empurra para o próximo
        if (need === 1) {
          state.msg = 'Falta 1 peça para ' + (nextIsMax
            ? ('o desconto máximo de ' + next.pct + '% OFF')
            : ('desbloquear ' + next.pct + '% OFF'));
          state.urgent = true;
        } else {
          state.msg = 'Faltam ' + need + ' peças para ' + next.pct + '% OFF';
        }
      }
    }
    return state;
  }

  /* ---------- Marcadores: gerados dos tiers, idempotente por trilha ----------
     Markup vem só com a trilha + fill; os marcadores são criados aqui a partir do
     config (fonte única). Se a trilha for re-renderizada (cart drawer), reconstrói. */
  function ensureMarkers(track) {
    if (!track || track.getAttribute('data-dp-ready') === '1') return;
    for (var i = 0; i < TIERS.length; i++) {
      var pct = Math.min(TIERS[i].min / MAX_MIN, 1) * 100;
      var m = document.createElement('span');
      m.className = 'dp-sticky__marker';
      m.setAttribute('data-marker', String(TIERS[i].min));
      m.style.left = pct + '%';
      track.appendChild(m);
    }
    track.setAttribute('aria-valuemax', String(MAX_MIN));
    track.setAttribute('data-dp-ready', '1');
  }

  /* ---------- Render de UMA barra ---------- */
  function renderBar(bar, s, pecas) {
    var badge = bar.querySelector('.dp-sticky__badge');
    var msg   = bar.querySelector('.dp-sticky__msg');
    var track = bar.querySelector('.dp-sticky__track');
    var fill  = bar.querySelector('.dp-sticky__fill');
    ensureMarkers(track);

    if (badge) {
      if (s.badge) { badge.textContent = s.badge; badge.hidden = false; }
      else { badge.textContent = ''; badge.hidden = true; }
    }
    // ✓ em verde quando há desconto desbloqueado (string controlada internamente)
    if (msg) msg.innerHTML = s.msg.replace('✓', '<span class="dp-sticky__check">✓</span>');
    if (fill) fill.style.width = s.fill + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.min(pecas, MAX_MIN)));

    [].forEach.call(bar.querySelectorAll('.dp-sticky__marker'), function (m) {
      var th = parseInt(m.getAttribute('data-marker'), 10);
      m.classList.toggle('is-active', pecas >= th);
    });

    bar.classList.toggle('dp-sticky--urgent', s.urgent);
    bar.classList.toggle('dp-sticky--success', s.success);
    bar.classList.toggle('dp-sticky--empty', pecas <= 0);
  }

  /* ---------- Render de TODAS as barras (um update por mudança) ---------- */
  function render(pecas) {
    var s = buildState(pecas);
    // Re-query a cada render: o cart drawer pode re-renderizar e substituir a barra.
    var bars = document.querySelectorAll('.dp-sticky');
    [].forEach.call(bars, function (bar) { renderBar(bar, s, pecas); });

    // Celebração: só ao SUBIR de tier, nunca na carga inicial nem ao diminuir.
    if (lastTierIndex !== null && s.idx > lastTierIndex && !reduceMotion) {
      [].forEach.call(bars, function (bar) {
        bar.classList.remove('dp-sticky--celebrate');
        void bar.offsetWidth; // reinicia a animação
        bar.classList.add('dp-sticky--celebrate');
      });
      clearTimeout(celebrateTimer);
      celebrateTimer = setTimeout(function () {
        [].forEach.call(document.querySelectorAll('.dp-sticky'), function (bar) {
          bar.classList.remove('dp-sticky--celebrate');
        });
      }, 650);
    }
    lastTierIndex = s.idx;
  }

  /* ---------- Carrinho ---------- */
  function countPieces(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, it) {
      var h = (it.handle || '').toLowerCase();
      if (EXCLUDED.indexOf(h) !== -1) return sum;
      return sum + (it.quantity || 0);
    }, 0);
  }

  var fetching = false;
  function fetchAndRender() {
    if (fetching) return;
    fetching = true;
    // cache-busting + no-store: /cart.js às vezes vem do cache do navegador e
    // ignoraria uma remoção recente, deixando a barra "presa" no maior valor.
    fetch('/cart.js?ts=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(countPieces(cart)); })
      .catch(function () { /* mantém o estado atual em caso de falha */ })
      .then(function () { fetching = false; });
  }

  // Debounce: múltiplas adições rápidas não causam flicker.
  var debounceTimer = null;
  function refresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndRender, 150);
  }
  window.MinimalProgressBar = { refresh: refresh };

  /* ---------- Visibilidade no scroll (só a barra FIXA do topo) ---------- */
  window.addEventListener('scroll', function () {
    var fixedBars = document.querySelectorAll('.dp-sticky:not(.dp-sticky--in-cart)');
    [].forEach.call(fixedBars, function (bar) {
      if (!hero) { bar.classList.add('dp-sticky--visible'); return; }
      bar.classList.toggle('dp-sticky--visible', hero.getBoundingClientRect().bottom < 0);
    });
  }, { passive: true });

  /* ---------- Eventos de carrinho (100% orientado a evento) ---------- */
  document.addEventListener('cart:updated', refresh); // Compra Rápida (quick-add-minimal)
  document.addEventListener('cart:refresh', refresh);
  // pubsub do tema: cobre add/remoção/qty no cart drawer e demais fluxos nativos
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  // bfcache: voltar do checkout pelo botão "voltar"
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchAndRender(); });

  // Rede: pega QUALQUER mutação de carrinho (à prova de tema/app). Adds publicam
  // cartUpdate, mas remoção/qty no cart drawer nem sempre chega à barra via pubsub.
  // Envelopamos o fetch para reagir a /cart/{add,change,update,clear} — sem alterar
  // a resposta, só disparando um refresh depois que a requisição resolve.
  if (!window.__dpCartFetchPatched && typeof window.fetch === 'function') {
    window.__dpCartFetchPatched = true;
    var _origFetch = window.fetch;
    var CART_MUTATION = /\/cart\/(?:add|change|update|clear)\b/i;
    window.fetch = function () {
      var url = '';
      try { url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (e) {}
      var p = _origFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) { p.then(refresh, function () {}); }
      return p;
    };
  }

  /* ---------- Init ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndRender);
  } else {
    fetchAndRender();
  }
})();
